import { Star } from 'lucide-react';
import { Reveal } from './Reveal.tsx';
import type { SiteConfig, Testimonial } from '../../siteContentTypes.ts';

const TYPE_LABELS: Record<Testimonial['type'], string> = {
  EXTRA: 'Extra',
  RESTAURATEUR: 'Restaurateur',
  TRAITEUR: 'Traiteur',
};

function TestimonialCard({ item }: { item: Testimonial }) {
  return (
    <div className="card" style={{ minWidth: 280, maxWidth: 340, display: 'flex', flexDirection: 'column', gap: 12, flexShrink: 0 }}>
      <div style={{ display: 'flex', gap: 2 }}>
        {Array.from({ length: 5 }).map((_, i) => (
          <Star key={i} size={14} color="var(--accent)" fill={i < item.rating ? 'var(--accent)' : 'none'} />
        ))}
      </div>
      <p style={{ fontSize: 14, lineHeight: 1.6, margin: 0, color: 'var(--text)' }}>&ldquo;{item.text}&rdquo;</p>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginTop: 4 }}>
        <div
          style={{
            width: 36,
            height: 36,
            borderRadius: '50%',
            background: 'var(--accent-tint)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: 800,
            color: 'var(--accent-dark)',
            overflow: 'hidden',
            flexShrink: 0,
          }}
        >
          {item.photo ? <img src={item.photo} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : item.firstName[0]}
        </div>
        <div>
          <div style={{ fontWeight: 700, fontSize: 13 }}>
            {item.firstName} {item.lastName}
          </div>
          <div style={{ fontSize: 11.5, color: 'var(--text-tertiary)' }}>
            {TYPE_LABELS[item.type]}
            {item.location ? ` · ${item.location}` : ''}
          </div>
        </div>
      </div>
    </div>
  );
}

export function Testimonials({ config }: { config: SiteConfig }) {
  const items = config.testimonials.items.filter((t) => t.visible).sort((a, b) => a.order - b.order);
  if (items.length === 0) return null;

  return (
    <section id="temoignages" style={{ padding: '56px 0', maxWidth: 1160, margin: '0 auto' }}>
      <Reveal className="screen-content" >
        <h2 style={{ textAlign: 'center', fontSize: 28, fontWeight: 800, margin: '0 24px 28px' }}>{config.testimonials.title}</h2>
      </Reveal>
      <div
        style={{
          display: 'flex',
          gap: 16,
          overflowX: 'auto',
          padding: '4px 24px 12px',
          scrollSnapType: 'x mandatory',
        }}
      >
        {items.map((item) => (
          <div key={item.id} style={{ scrollSnapAlign: 'start' }}>
            <TestimonialCard item={item} />
          </div>
        ))}
      </div>
    </section>
  );
}
